<script>
import Layout from '@layouts/main.vue'
import {
  passwordResetConfirmMethods,
  passwordResetConfirmComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Password Reset',
    meta: [{ name: 'description', content: '' }],
  },
  name: 'PasswordResetConfirmView',
  components: { Layout },
  data() {
    return {
      passwordResetConfirmForm: {
        password1: '',
        password2: '',
        uid: this.$route.params.uid,
        token: this.$route.params.token,
      },
    }
  },
  computed: {
    ...passwordResetConfirmComputed,
  },
  methods: {
    ...passwordResetConfirmMethods,
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.passwordResetConfirmView" class="flex justify-center items-center">
      <template v-if="resetLoading">
        <Loader/>
      </template>
      <template v-else-if="!resetCompleted">

        <el-form class="w-full md:w-80 m-auto" status-icon label-width="85px" label-position="top">
            <span v-show="resetError" class="e-server-error">
              An error occurred while processing your request. Please contact
              support.
            </span>

          <el-form-item class="basic" label="New password">
            <el-input
                v-model="passwordResetConfirmForm.password1"
                type="password"
                placeholder="•••••••••••••••"></el-input>
          </el-form-item>

          <el-form-item class="basic" label="Repeat password">
            <el-input
                v-model="passwordResetConfirmForm.password2"
                type="password"
                placeholder="•••••••••••••••"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
                type="primary"
                round
                @click.prevent="resetPassword(passwordResetConfirmForm)">
              Change Password
            </el-button>
          </el-form-item>

          <div class="">
            <router-link class="text-sm underline" :to="{ name: 'login' }">Back to login</router-link>
          </div>
        </el-form>
      </template>

      <template v-else>
        <div class="w-full md:w-80 m-auto">
          <img class="OnvocadoLogo" src="/onvocado_logo.png" alt="Onvocado Logo">
          <h3 class="mb-2 text-lg">Your password has been changed!</h3>
          <p class="mb-6">You can now use your new password to login.</p>
          <router-link
              :to="{ name: 'login' }"
              tag="button"
              type="primary"
              class="btn primary large">
            To login page
          </router-link>
        </div>
      </template>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@assets/sass/design/_mixin.scss';

.passwordResetConfirmView {
  @include pageDefaults;
  @apply mx-4 md:mx-auto;

  display: flex;
  height: calc(100vh - 60px);
}
</style>
